import { type MatterExpense } from "@/lib/types";

export const calculateExpenseTotals = (
  expenses: Pick<
    MatterExpense,
    "cost" | "reducedAmount" | "paidAmount" | "refunded" | "refundedAmount"
  >[],
) => {
  const totalExpenses = expenses.reduce(
    (acc, expense) => acc + Number(expense.reducedAmount || expense.cost || 0),
    0,
  );
  const totalPaid = expenses.reduce(
    (acc, expense) => acc + Number(expense.paidAmount || 0),
    0,
  );
  const totalRefunded = expenses.reduce((acc, expense) => {
    if (expense.refunded) {
      return acc + Number(expense.refundedAmount || 0);
    }
    return acc;
  }, 0);
  return {
    totalExpenses,
    totalPaid,
    totalRefunded,
    totalBalanceRemaining: totalExpenses - totalPaid + totalRefunded,
  };
};
